import React from 'react';
import { Icon } from '@@Components/Icon/Icon';
import { useLang } from '@@Hooks/useLang';
import { useSelector } from 'react-redux';
import { currentStoreLocationSelector } from '@@Redux/selectors/storelocator.selectors';
import { defaultCountrySelector } from '@@Redux/selectors/mageconfig.selectors';
import dayjs from 'dayjs';
import 'dayjs/locale/pl';
import localeData from 'dayjs/plugin/localeData';
import LSF from '@@Storefront';
import get from 'lodash/get';
import { HoursWrapper, ContactInformationContainer, Street, Title, Text, PhoneMailLink, SocialLink } from './styled';
dayjs.extend(localeData);
dayjs.locale('pl');
const prepareHours = (operationHoursData) => {
    try {
        const { mageConfig } = LSF.getState();
        const defaultHours = get(mageConfig, 'storelocator.time_default', {});
        const preparedData = Object.entries(operationHoursData).map(([key, value], index) => {
            const shortDayname = key.replace('operation_', '');
            if (value === 'use_config') {
                const foundKey = Object.keys(defaultHours).find(key => key.slice(0, 3) === shortDayname);
                let hoursDataParsed = null;
                try {
                    hoursDataParsed = JSON.parse(defaultHours[foundKey]);
                    return hoursDataParsed[foundKey];
                }
                catch (error) {
                    return null;
                }
            }
            else
                return value;
        });
        return preparedData;
    }
    catch (error) {
        return {};
    }
};
export const ContactInformation = () => {
    const currentLocation = useSelector(currentStoreLocationSelector);
    const currentLanguage = useSelector(defaultCountrySelector);
    if (!currentLocation || !currentLanguage)
        return null;
    const { operation_mon, operation_tue, operation_wed, operation_thu, operation_fri, operation_sat, operation_sun } = currentLocation;
    const hoursData = prepareHours({
        operation_mon,
        operation_tue,
        operation_wed,
        operation_thu,
        operation_fri,
        operation_sat,
        operation_sun
    });
    const { translate } = useLang();
    const weekdays = dayjs().localeData().weekdays();
    return (React.createElement(ContactInformationContainer, null,
        currentLocation.name && React.createElement(Title, null, currentLocation.name),
        currentLocation.street && React.createElement(Street, null, currentLocation.street),
        React.createElement(HoursWrapper, null, Object.entries(hoursData).map(([key, value], index) => {
            try {
                const shortDayname = key.replace('operation_', '');
                const dayName = get(weekdays, `[${(index + 1) % 7}]`, shortDayname);
                const hoursFrom = get(value, 'from', []);
                const hoursTo = get(value, 'to', []);
                const hoursValid = hoursFrom.length === 2 && hoursFrom.length === 2;
                return hoursValid && (value === null || value === void 0 ? void 0 : value.value) === '1' ? React.createElement("div", { style: { display: 'flex' } },
                    React.createElement(Text, { textTransform: 'capitalize', style: { width: '100px' } }, dayName),
                    React.createElement(Text, null,
                        hoursFrom[0],
                        ":",
                        hoursFrom[1],
                        " - ",
                        hoursTo[0],
                        ":",
                        hoursTo[1])) : React.createElement(React.Fragment, null);
            }
            catch (error) {
                return React.createElement(React.Fragment, null);
            }
        })),
        React.createElement(PhoneMailLink, { href: `mailto:${currentLocation.email}` }, currentLocation.email),
        currentLocation.phone_one && React.createElement(PhoneMailLink, { underline: true, href: `tel:${currentLocation.phone_one}` }, currentLocation.phone_one),
        currentLocation.phone_two && React.createElement(PhoneMailLink, { underline: true, href: `tel:${currentLocation.phone_two}` }, currentLocation.phone_two),
        currentLocation.facebook &&
            React.createElement(SocialLink, { href: currentLocation.facebook },
                React.createElement(Icon, { icon: 'facebook' }),
                React.createElement(Text, { padding: '0 0 0 10px' }, translate('actions.see_us_on_facebook')))));
};
